import React from "react";
import { Routes, Route } from 'react-router-dom';

import TeamDashboard from './../Pages/Team/Dashboard';
import TeamLeads from './../Pages/Team/Leads/Lead';
import TeamLeadEdit from './../Pages/Team/Leads/EditLead';
import TeamLeadFilter from './../Pages/Team/Leads/LeadFilter';
import LeadProfile from './../Pages/Team/Leads/LeadProfile';

import TeamActivityLogs from './../Pages/Team/ActivityLogs/Logs';

import TeamRemarks from './../Pages/Team/Remarks';

import Callers from './../Pages/Team/Callers';
import Reports from './../Pages/Team/Reports/Report';

import Notifications from './../Pages/Team/Notifications';
import NotificationFilterDataList from './../Pages/Team/NotificationFilterDataList';

import TeamProfile from './../Pages/Team/TeamProfile';

//import AuthChecker from './../Pages/AuthenticationChecker';

//import NotFound from './../Pages/NotFound';

const Team = [
    {
        path: "team/dashboard", 
        element: <TeamDashboard />,
    },
    {
        path: "team/leads", 
        element: <TeamLeads />,
    },
    {
        path: "team/lead/:leadid/edit", 
        element: <TeamLeadEdit />,
    },
    {
        path: "team/lead/:filtertype", 
        element: <TeamLeadFilter />,
    },
    {
        path: "team/lead-profile/:leadid", 
        element: <LeadProfile />,
    },
    {
        path: "team/activity-logs", 
        element: <TeamActivityLogs />,
    },
    {
        path: "team/callers", 
        element: <Callers />,
    },
    {
        path: "team/remarks", 
        element: <TeamRemarks />,
    },
    {
        path: "team/notifications", 
        element: <Notifications />,
    },
    {
        path: "team/notification/:filtertype", 
        element: <NotificationFilterDataList />,
    },
    {
        path: "team/reports", 
        element: <Reports />,
    },
    {
        path: "team/profile", 
        element: <TeamProfile />,
    },
];

export default Team;